//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProgressRing from './ProgressRing.vue';
export default {
  name: 'FilePreview',
  props: ['file', 'force_private_public'],
  components: {
    ProgressRing
  },
  data() {
    return {
      src: null
    }
  },
  mounted() {
    //$('[data-toggle="tooltip"]').tooltip();
    if (this.is_image) {
      if (window.FileReader) {
        let fr = new FileReader();
        fr.onload = () => this.src = fr.result;
        fr.readAsDataURL(this.file.file_obj);
      }
    }
  },
  filters: {
    file_size(value) {
      return frappe.form.formatters.FileSize(value);
    },
    file_name(value) {
			return value;
			// return frappe.utils.file_name_ellipsis(value, 9);
    }
  },
  computed: {
		private_icon() {
			return frappe.utils.icon(this.is_private ? 'lock' : 'unlock');
		},
		is_private() {
			return this.file.doc ? this.file.doc.is_private : this.file.private;
		},
    uploaded() {
      return this.file.total && this.file.total === this.file.progress && !this.file.failed;
    },
    is_image() {
      return this.file.file_obj.type.startsWith('image');
		},
		progress() {
			let value = Math.round((this.file.progress * 100) / this.file.total);
			if (isNaN(value)) {
				value = 0;
			}
			return value;
    }
  }
}
